// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyPolicy_root__R86ba","lastUpdated":"PrivacyPolicy_lastUpdated__3h1Oj"};